import React from 'react';
import { PolicyContext, PolicyData } from '../../context/policy';
import BreadcrumbsContainer, { Breadcrumb } from '../BreadcrumbsContainer';

interface Props {
	policyData: PolicyData;
}

const Breadcrumbs = (props: Props) => {
	const { policy } = props.policyData;
	const { locator, policyholderLocator } = policy;

	const breadcrumbs: Breadcrumb[] = [
		{ href: `/policyholder/${policyholderLocator}`, text: 'Policyholder' },
		{ href: `/policy/${locator}/details`, text: `Policy ${locator}` },
		{ href: null, text: 'Claim' },
	];
	return <BreadcrumbsContainer breadcrumbs={breadcrumbs} />;
};

function withContext<T>(Component: any) {
	return (props: Omit<T, 'policyData'>) => (
		<PolicyContext.Consumer>
			{(policyData) => <Component {...props} policyData={policyData} />}
		</PolicyContext.Consumer>
	);
}

export default withContext<Props>(Breadcrumbs);
